import { useEffect, useMemo } from 'react';

import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useGetEmployerIdParam } from '../../hooks';
import { useBaseReportTableQuery } from '../../queries';
import { HealthPlanEnrollmentsReportTableParams } from '../HealthPlanEnrollmentReport.types';

export const QUERY_KEY = 'FORFEITURE_REPORT_QUERY';

const MIN_SEARCH_LEN = 3;
const useHealthPlanEnrollmentsReportQuery = (params: Partial<HealthPlanEnrollmentsReportTableParams>) => {
  const currentSearch = useMemo(() => {
    if (!!params?.searchString && params?.searchString?.length >= MIN_SEARCH_LEN) {
      return params.searchString;
    }
    return null;
  }, [params.searchString]);
  const getEmployerIdParam = useGetEmployerIdParam();
  const employersIds = useMemo(() => {
    return params?.employerIds?.join(',');
  }, [params?.employerIds]);

  const base = useBaseReportTableQuery(
    API_URL.REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_BREAKDOWN,
    [
      QUERY_KEY,
      currentSearch,
      params.employerId,
      params.reportPlanIds?.join(','),
      params.planYearPeriod?.join(','),
      employersIds,
    ],
    {
      ...getEmployerIdParam(params.employerId, params.employerIds),
      show_ssn: true,
      plan_year_period:
        params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
          ? params?.planYearPeriod.join(',')
          : undefined,
      plan_ids:
        params?.reportPlanIds && !params?.reportPlanIds.includes(ALL_OPTION_KEY)
          ? params?.reportPlanIds.join(',')
          : undefined,
      isSSNShowed: params.isSSNShowed,
      search_value: currentSearch,
    },
    {
      isMultipleEmployers: params.isMultipleEmployer,
      isPreviewMode: params.isPreviewMode,
    }
  );

  useEffect(() => {
    base.onChangePlanOptions([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.employerId, employersIds]);

  useEffect(() => {
    base.setPage(0);
    base.setRawContentList([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.employerId, params?.searchString, employersIds, params?.reportPlanIds, params?.planYearPeriod]);
  return base;
};

export default useHealthPlanEnrollmentsReportQuery;
